export const vibrateThenDo = (
  callback: () => void,
  vibratePattern: VibratePattern = 10
) => {
  window.navigator.vibrate(vibratePattern);
  callback();
};
